import { render } from "./UsersList.vue?vue&type=template&id=64714036&rel=stylesheet&href=https%3A%2F%2Fcdn.bootcss.com%2Fbootstrap%2F3.3.5%2Fcss%2Fbootstrap.css"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__